<template>
  <a href="javascript:" @click="del" v-if="isShowDel">删除</a>
</template>

<script>
export default {
  props: {
    commentId: { type: Number, required: true },
    authId: { type: Number, required: true },
  },
  computed: {
    isShowDel() {
      console.log(11111111, this.loginUser, this.commentId);
      if (this.loginUser) {
        return this.authId === this.loginUser.userId;
      } else {
        return false;
      }
    },
  },
  methods: {
    del() {
      if (this.commentId > 0) {
        let params = {
          Id: this.commentId,
        };
        this.$api.common.deleteMsg(params).then((res) => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: this.$t('message.operatesuccessfully'),
            });
            this.$emit("delSuccess");
          }
        });
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/common/deleteComment.vue